export const glassSurface = [
  "bg-transparent bg-gradient-to-b from-glass-from to-glass-to",
  "backdrop-blur-xl",
  "shadow-glass-base",
].join(" ");

export const glassTrayBelowDesk = [
  "max-desk:p-1.5 max-desk:rounded-pill max-desk:bg-gradient-to-b",
  "max-desk:from-glass-from max-desk:to-glass-to max-desk:backdrop-blur-xl",
  "max-desk:shadow-glass-tray",
].join(" ");

export const glassPopover =
  "bg-popover backdrop-blur-xl shadow-glass-pop";

export const signatureGlass = [
  "bg-signature/[0.14]",
  "shadow-[inset_0_0_0_1px_rgb(var(--signature)/0.55),var(--signature-edge-hi)]",
].join(" ");
